import type { DocumentSummary } from '../api/types';

/** Marks a drag as an in-app move; the upload drop zones ignore it. */
export const DRAG_TYPE = 'application/x-erp-attach-document';

export const isInternalDrag = (types: readonly string[]): boolean => types.includes(DRAG_TYPE);

/** The id for the move, plus the short link so dropping into Teams, Outlook or the address bar pastes it. */
export function setDragData(dt: DataTransfer, doc: Pick<DocumentSummary, 'id'>, link: string): void {
  dt.setData(DRAG_TYPE, doc.id);
  dt.setData('text/uri-list', link);
  dt.setData('text/plain', link);
  dt.effectAllowed = 'copyMove';
}
